'use client';
import React from 'react';
import { Item } from '@benzinga/news';
import { ContentManager, SponsoredContentArticlesParams } from '@benzinga/content-manager';
import { SessionPropsExtension } from '@benzinga/session-context';

export const useSponsoredContentArticle = (session: SessionPropsExtension, symbol?: string) => {
  const [sponsoredArticles, setSponsoredArticles] = React.useState<Item[]>([]);

  const contentManager = session.getManager(ContentManager);

  React.useEffect(() => {
    let params: SponsoredContentArticlesParams | undefined = undefined;

    if (symbol) {
      params = {
        tickers: symbol,
      };
    }

    contentManager
      .getSponsoredContentArticles(false, params)
      .then(response => {
        if (response?.ok) {
          setSponsoredArticles(response?.ok as Item[]);
        }
      })
      .catch(e => {
        console.log('Sponsored Article Error:', e);
      });
  }, [contentManager, symbol]);

  return [sponsoredArticles];
};
